
export const WORKING_DURATION = [
    { value: "0", label: "Currently studying"},
    { value: "1", label: "1-2 years"},
    { value: "3", label: "3-5 years"},
    { value: "5", label: "5-10 years"},
    { value: "10", label: "10+ years"},
]

export const EDUCATION_LEVEL = [
    { value: "HIGHSCHOOL", label: "High School"},
    { value: "COLLEGE", label: "Vocational College/ Technical School"},
    { value: "BACHELOR", label: "Bachelor's Degree"},
    { value: "MASTER", label: "Master's Degree"},
    { value: "PHD", label: "PhD"},
]

export const MENTOR_AVAILABILITY_OPTIONS = [
    { value: "1", label: "1-2 hours per day"},
    { value: "2", label: "2-3 hours per day"},
    { value: "4", label: "4+ hours per day"}
];

export const MENTOR_HACKATHON_EXP_OPTIONS = [
    { value: "1", label: "0-1 hackathon "},
    { value: "2", label: "2-3 hackathons"},
    { value: "4", label: "4-6 hackathons"},
    { value: "8", label: "8-10 hackathons"},
    { value: "10", label: "10+ hackathons"},
];

export const LEAD_MENTOR_OPTIONS = [
    { value: false, label: "No"},
    { value: true, label: "Yes"},
]

export const TEAM_STATUS_OPTIONS = [
    {value: "LOOKING", label: "LOOKING - Looking for an awesome team to join"},
    {value: "RECRUITING", label: "RECRUITING - In a team but looking to fill more competitor(s)"},
    {value: "OCCUPIED", label: "OCCUPIED - In a fully resourced team, ready to compete"},
];

export const TEAM_CHALLENGE_OPTIONS = [
    {value: "PREDICT", label: "Predictive Algorithm"},
    {value: "NLP", label: "Natural Language Processing"},
    {value: "VISUAL", label: "Visualisation Challenge"}
];


export const HACKATHON_EXP_OPTIONS = [
    { value: "1", label: "0-1 hackathon "},
    { value: "2", label: "2-3 hackathons"},
    { value: "4", label: "4-6 hackathons"},
    { value: "8", label: "8-10 hackathons"},
    { value: "10", label: "10+ hackathons"},
];

export const PRIMARY_SKILL_OPTIONS = [
    { value: "DATA", label: "Data: analysing and actioning the data"},
    { value: "DESIGN", label: "Design: Graphics and presentations"},
    { value: "DOMAIN", label: "Domain: Understanding the industry and challenges"},
    { value: "LEADERSHIP", label: "Leadership: organising a team"},
    { value: "PRESENTATION", label: "Presentations: Communicating the findings"},
    { value: "DEVELOPMENT", label: "Software development: building a solution"},
];

export const HACKATION_ROLES = {
    competitor:     "COMPETITOR",
    mentor:         "MENTOR"
}
export const HACKATHON_ROLE_OPTIONS = [
    {value: HACKATION_ROLES.competitor, label: "Competitor - I'm here to hack!"},
    {value: HACKATION_ROLES.mentor, label: "Mentor - I'm here to help hackers!"},
    //{value: "VOLUNTEER", label: "Volunteer - I'm here to help everyone!"}
]

export const PROF_BACKGROUND_OPTIONS = [
    { value: "AGRICULTURE", label: "Agriculture; plantations;other rural sectors"},
    { value: "CHEMICAL", label: "Chemical industries"},
    { value: "COMMERCE", label: "Commerce & Business"},
    { value: "CONSTRUCTION", label: "Construction"},
    { value: "DATA_SCI", label: "Data Science; statistics"},
    { value: "EDUCATION", label: "Education"},
    { value: "FINANCE", label: "Financial services"},
    { value: "FOOD", label: "Food; drink"},
    { value: "HEALTH", label: "Health services"},
    { value: "HOSPITALITY", label: "Hotels; tourism; catering"},
    { value: "HR", label: "Human Resources"},
    { value: "SOFTWARE", label: "ICT, Software Engineering"},
    { value: "MECHANICAL", label: "Mechanical and electrical engineering"},
    { value: "MEDIA", label: "Media; culture; design, graphical"},
    { value: "OILGAS", label: "Oil and gas production; oil refining"},
    { value: "TELECOMMUNICATION", label: "Postal and telecommunications services"},
    { value: "CONSULTING", label: "Professional services, product management & consulting"},
    { value: "GOVERNMENT", label: "Public service; Government"},
    { value: "OTHER", label: "Other"},
];

export const EDU_BACKGROUND_OPTIONS = [
    { value: "AGRICULTURE", label: "Agriculture"},
    { value: "BUSINESS", label: "Business; Finance; Accounting"},
    { value: "COMP_SCI", label: "Computer Science"},
    { value: "EDUCATION", label: "Education"},
    { value: "ARTS", label: "Design and Arts"},
    { value: "DATA_SCI", label: "Data Science; statistics"},
    { value: "ENGINEERING", label: "Engineering"},
    { value: "HEALTH", label: "Health Science"},
    { value: "HUMANITIES", label: "Humanities"},
    { value: "LAW", label: "Law"},
    { value: "ADMIN", label: "Senior administration"},
    { value: "SOCIAL_SCI", label: "Social Science"},
    { value: "OTHER", label: "Other"},
];